import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAvailableTrainersData } from "../../../redux/live-reducers/liveSlice";
import CommonTable from "../../common-components/common-tables/CommonTable";
import {
  CallIcon,
  CheckIcon,
  ClockIconV3,
  PersonIcon,
  LocationIcon1,
  CalendarIcon,
  RupeeIcon,
  FileIcon,
} from "../../../images/icons/icons";
import {
  formatDateTime,
  convertStraight,
  convertThenFormat,
} from "../../common-data/Converts";
import { getCardIcon } from "../live-subs/mockSubscriptionData";

const AvailableTrainers = ({
  userInfoData,
  rowData,
  closeModal,
  isOnlyMemberInfo = false,
}) => {
  const dispatch = useDispatch();
  const {
    availableTrainers,
    availableTrainersError,
    availableTrainersLoading,
  } = useSelector((state) => state.live);

  const [tdData, setTdData] = useState(null);

  const iniFilters = {
    notification_log_id: rowData?.uid || "",
  };

  function getAvailableTrainers(filters) {
    dispatch(
      fetchAvailableTrainersData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    if (iniFilters?.notification_log_id) {
      getAvailableTrainers(iniFilters);
    }
  }, []);

  useEffect(() => {
    if (
      !availableTrainersLoading &&
      !availableTrainersError &&
      availableTrainers?.status &&
      availableTrainers?.data
    ) {
      setTdData(availableTrainers.data);
    } else {
      setTdData([]);
    }
  }, [availableTrainersLoading, availableTrainersError, availableTrainers]);

  const tbColumns = [
    {
      dataField: "trainer_id",
      text: "trainer checked-in",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <PersonIcon />
              </span>{" "}
              <span className="tb-data">{row?.trainer_name || "NA"}</span>{" "}
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <CallIcon />
              </span>{" "}
              <span className="tb-data">{row?.trainer_mobile || "NA"}</span>{" "}
            </div>
          </div>
        );
      },
    },
    {
      dataField: "trainer_name",
      text: "assigned trainer",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <PersonIcon />
              </span>{" "}
              <span className="tb-data">{row?.trainer_name || "NA"}</span>{" "}
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <CallIcon />
              </span>{" "}
              <span className="tb-data">{row?.trainer_mobile || "NA"}</span>{" "}
            </div>
          </div>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Trainer Checkin Time",
      formatter: (_, row) => {
        return (
          <div className="tb-flex">
            <span className="tb-data tb-info-icon">
              <ClockIconV3 color="#2c3e50" />
            </span>{" "}
            <span className="tb-data">
              {formatDateTime(row?.date_added || "-")}
            </span>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <div className="live-member-info-header">
        <button
          className="live-member-info-close-btn"
          onClick={closeModal}
          title="Close"
        >
          ×
        </button>

        <div className="live-member-info-header-main">
          <div className="live-member-info-header-icon">
            <PersonIcon color="#1f2937" />
          </div>
          <div>
            <h3 className="live-member-info-header-title">
              {rowData?.user_name || rowData?.name || "NA"}
            </h3>
            <p className="live-member-info-header-subtitle">
              Checked-in Member
            </p>
          </div>
        </div>

        <div className="live-member-info-grid">
          <div className="live-member-info-item">
            <CallIcon color="#1f2937" className="live-member-info-item-icon" />
            <span className="live-member-info-item-text">
              {rowData?.user_mobile || rowData?.mobile || "NA"}
            </span>
          </div>

          <div className="live-member-info-item">
            <LocationIcon1
              color="#1f2937"
              className="live-member-info-item-icon"
            />
            <span className="live-member-info-item-text">
              {rowData?.gym_name || "NA"}
            </span>
          </div>
        </div>

        <div className="live-member-info-checkin">
          <ClockIconV3
            color="#1f2937"
            className="live-member-info-checkin-icon"
          />
          <span className="live-member-info-checkin-text">
            Checkin Time: {formatDateTime(rowData?.date_added || "-")}
          </span>
        </div>
      </div>

      {!isOnlyMemberInfo && (
        <>
          <div className="live-member-subscription-info">
            <h4 className="live-member-subscription-title">
              Current Subscription
            </h4>
            <div className="live-member-subscription-grid">
              <div className="live-member-subscription-item">
                {getCardIcon("total")}

                <div className="live-member-subscription-details">
                  <span className="live-member-subscription-label">
                    Plan Name
                  </span>
                  <span className="live-member-subscription-value">
                    {rowData?.current_plan_name || rowData?.plan_name || "NA"}
                  </span>
                </div>
              </div>

              <div className="live-member-subscription-item">
                <RupeeIcon
                  color="#1f2937"
                  className="live-member-subscription-icon"
                />
                <div className="live-member-subscription-details">
                  <span className="live-member-subscription-label">
                    Plan price
                  </span>
                  <span className="live-member-subscription-value">
                    {convertThenFormat(rowData?.current_plan_price || 0)}
                  </span>
                </div>
              </div>

              <div className="live-member-subscription-item">
                <CalendarIcon
                  color="#1f2937"
                  className="live-member-subscription-icon"
                />
                <div className="live-member-subscription-details">
                  <span className="live-member-subscription-label">
                    Start Date
                  </span>
                  <span className="live-member-subscription-value">
                    {convertStraight(
                      rowData?.current_subscription_start_date ||
                        rowData?.start_date
                    ) || "NA"}
                  </span>
                </div>
              </div>

              <div className="live-member-subscription-item">
                <CalendarIcon
                  color="#1f2937"
                  className="live-member-subscription-icon"
                />
                <div className="live-member-subscription-details">
                  <span className="live-member-subscription-label">
                    Expire Date
                  </span>
                  <span className="live-member-subscription-value">
                    {convertStraight(
                      rowData?.current_subscription_expire_date ||
                        rowData?.expire_date
                    ) || "NA"}
                  </span>
                </div>
              </div>

              <div className="live-member-subscription-item">
                <ClockIconV3
                  color="#1f2937"
                  className="live-member-subscription-icon"
                />
                <div className="live-member-subscription-details">
                  <span className="live-member-subscription-label">
                    Remaining Days
                  </span>
                  <span className="live-member-subscription-value">
                    {rowData?.subscription_expiry_days ||
                      rowData?.days_remaining ||
                      "NA"}
                  </span>
                </div>
              </div>

              <div className="live-member-subscription-item">
                <div className="live-member-subscription-details">
                  <span className="live-member-subscription-label">
                    plan Status
                  </span>
                  <span
                    className={`tb-badge ${
                      rowData?.current_plan_status === "active" ||
                      rowData?.plan_status === "active"
                        ? "tb-fresh"
                        : "tb-existing"
                    }`}
                  >
                    {rowData?.current_plan_status ||
                      rowData?.plan_status ||
                      "NA"}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {rowData?.three_day_assigned === 1 && (
            <div className="live-member-trial-info">
              <h4 className="live-member-trial-title">
                3-Day Trial Information
              </h4>
              <div className="live-member-trial-grid">
                <div className="live-member-trial-item">
                  <CalendarIcon
                    color="#1f2937"
                    className="live-member-trial-icon"
                  />
                  <div className="live-member-trial-details">
                    <span className="live-member-trial-label">Start Date</span>
                    <span className="live-member-trial-value">
                      {convertStraight(
                        rowData?.threeday_start_date?.split("T")[0]
                      ) || "NA"}
                    </span>
                  </div>
                </div>

                <div className="live-member-trial-item">
                  <CalendarIcon
                    color="#1f2937"
                    className="live-member-trial-icon"
                  />
                  <div className="live-member-trial-details">
                    <span className="live-member-trial-label">Expire Date</span>
                    <span className="live-member-trial-value">
                      {convertStraight(
                        rowData?.threeday_expire_date?.split("T")[0]
                      ) || "NA"}
                    </span>
                  </div>
                </div>

                <div className="live-member-trial-item">
                  <ClockIconV3
                    color="#1f2937"
                    className="live-member-trial-icon"
                  />
                  <div className="live-member-trial-details">
                    <span className="live-member-trial-label">Progress</span>
                    <span className="live-member-trial-value">
                      {rowData?.three_day_done_count || 0} / 3 session completed
                    </span>
                  </div>
                </div>

                <div className="live-member-trial-item">
                  <div className="live-member-trial-details">
                    <span className="live-member-trial-label">
                      Trial Status
                    </span>
                    <span
                      className={`tb-badge ${
                        rowData?.three_day_done_count >= 3
                          ? "tb-fresh"
                          : rowData?.three_day_done_count > 0
                          ? "tb-existing"
                          : "tb-pending"
                      }`}
                    >
                      {rowData?.three_day_done_count >= 3
                        ? "Completed"
                        : rowData?.three_day_done_count > 0
                        ? "In Progress"
                        : "Not Started"}
                    </span>
                  </div>
                </div>

                {rowData?.is_stuck === 1 && (
                  <>
                    <div className="live-member-trial-item">
                      <ClockIconV3
                      // color="#dc2626"
                      />
                      <div className="live-member-trial-details">
                        <span className="live-member-trial-label">
                          Stuck Duration
                        </span>
                        <span
                          className="live-member-trial-value"
                          style={{ color: "#dc2626" }}
                        >
                          {rowData?.stuck_time || "NA"}
                        </span>
                      </div>
                    </div>

                    <div className="live-member-trial-item">
                      <div className="live-member-trial-details">
                        <span className="live-member-trial-label">
                          Stuck Status
                        </span>
                        <span
                          className={`tb-badge ${
                            rowData?.stuck_for_7_or_more_days === 1
                              ? "tb-danger"
                              : "tb-warning"
                          }`}
                        >
                          {rowData?.stuck_for_7_or_more_days === 1
                            ? "Stuck 7+ Days"
                            : "Recently Stuck"}
                        </span>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          )}

          {rowData?.is_resolved === 1 && (
            <div className="live-member-resolution-info">
              <div className="live-member-resolution-header">
                <h4 className="live-member-resolution-title">
                  Resolution Information
                </h4>
                <span className="tb-badge tb-fresh">✓ Resolved</span>
              </div>

              <div className="live-member-resolution-grid">
                <div className="live-member-resolution-item">
                  <PersonIcon color="#10b981" />
                  <div className="live-member-resolution-details">
                    <span className="live-member-resolution-label">
                      Resolved By
                    </span>
                    <span className="live-member-resolution-value">
                      {rowData?.resolved_by_name || "NA"}
                    </span>
                  </div>
                </div>

                <div className="live-member-resolution-item">
                  <CallIcon color="#10b981" />
                  <div className="live-member-resolution-details">
                    <span className="live-member-resolution-label">
                      Contact
                    </span>
                    <span className="live-member-resolution-value">
                      {rowData?.resolved_by_mobile || "NA"}
                    </span>
                  </div>
                </div>

                <div className="live-member-resolution-item">
                  <ClockIconV3 color="#10b981" />
                  <div className="live-member-resolution-details">
                    <span className="live-member-resolution-label">
                      Resolution Date
                    </span>
                    <span className="live-member-resolution-value">
                      {formatDateTime(rowData?.resolved_date || "-")}
                    </span>
                  </div>
                </div>

                <div className="live-member-resolution-item">
                  <CheckIcon color="#10b981" />
                  <div className="live-member-resolution-details">
                    <span className="live-member-resolution-label">
                      Resolution Type
                    </span>
                    <span className="live-member-resolution-value">
                      {rowData?.resolution?.replace(/_/g, " ") || "NA"}
                    </span>
                  </div>
                </div>

                <div className="live-member-resolution-item span2">
                  <FileIcon color="#10b981" />
                  <div className="live-member-resolution-details">
                    <span className="live-member-resolution-label">
                      Remarks
                    </span>
                    <span className="live-member-resolution-value">
                      {rowData?.remarks || "NA"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="common-table-container mt15">
            {tdData && tdData.length === 0 ? (
              <div className="live-no-trainers-message">
                <div className="live-no-trainers-icon">
                  <PersonIcon color="#6b7280" />
                </div>
                <h4 className="live-no-trainers-title">
                  No Trainers Available
                </h4>
                <p className="live-no-trainers-description">
                  No trainers were available during this member's check-in
                  shift.
                </p>
              </div>
            ) : (
              <>
                <div className="live-trainers-info-header">
                  <h4 className="live-trainers-info-title">
                    Available Trainers
                  </h4>
                  <p className="live-trainers-info-description">
                    Trainers who were available during this member's check-in
                    shift
                  </p>
                </div>
                <CommonTable
                  tableData={tdData}
                  tableColumns={tbColumns}
                  isLoading={availableTrainersLoading}
                />
              </>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default AvailableTrainers;
